import { render, staticRenderFns } from "./TagAdd.vue?vue&type=template&id=43d7b2e8"
import script from "./TagAdd.vue?vue&type=script&lang=js"
export * from "./TagAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports